export default "/_next/static/images/d30ea6d708c2dd40a36f4ff2452d24bb.jpg";